import styled from 'styled-components'

export const ModalBackdrop = styled.div`
  opacity: 1;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100%;
  height: 100vh;
  background-color: #000000ba;
`

export const ModalComponent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: auto;
  pointer-events: auto;
`

export const ModalDialog = styled.div`
  max-width: ${({ width }) => (width ? `${width}px` : '360px')};
  width: 100%;
  position: absolute;
  max-height: ${({ height }) => (height ? `${height}px` : '')};
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  bottom: 0;
  overflow: hidden;
`

export const ModalContent = styled.div`
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  outline: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  ${({ color }) => `border-left: 6px solid ${color}`};
`

export const ModalBody = styled.div`
  position: relative;
  padding: 16px 0px;
  line-height: 1.75rem;
  display: flex;
`
